import { GamificationLevels, RAGColourValue } from '../enums';
import { randomColours } from '../../design/colours/colours';
export function colourString(colour) {
    if (colour === "transparent")
        return "transparent";
    return "var(--".concat(colour, ")");
}
export function loadBalancedColourString(colour, value) {
    if (colour === void 0) { colour = 'load-balanced'; }
    var temp = colour === 'load-balanced' ? ragColourType(value) : colour;
    return colourString(temp);
}
export function randomColourString() {
    return colourString(randomColours[Math.floor(Math.random() * randomColours.length)]);
}
export function levelColourType(level) {
    switch (level) {
        case GamificationLevels.One:
            return 'baby-blue';
        case GamificationLevels.Two:
            return 'blue';
        case GamificationLevels.Three:
            return 'apple';
        case GamificationLevels.Four:
            return 'honey';
        default:
            return 'primary';
    }
}
export function ragColourType(value) {
    if (value <= RAGColourValue.R)
        return 'r';
    if (value <= RAGColourValue.A)
        return 'a';
    return 'g';
}
